module.exports = __webpack_public_path__ + "public/img/vipTop.867775c7.png";